import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import { Li, Span } from 'shared';
function stateFor(index, currentIndex) {
    if (index < currentIndex)
        return 'completed';
    if (index === currentIndex)
        return 'current';
    return 'pending';
}
function CompletedIcon() {
    return (_jsx("svg", { className: "pwa-stepper__icon", viewBox: "0 0 20 20", fill: "none", "aria-hidden": "true", children: _jsx("path", { d: "M5 10.5l3.2 3.2L15 7", stroke: "currentColor", strokeWidth: "2.4", strokeLinecap: "round", strokeLinejoin: "round" }) }));
}
function CurrentIcon() {
    return (_jsx("svg", { className: "pwa-stepper__icon", viewBox: "0 0 20 20", fill: "none", "aria-hidden": "true", children: _jsx("circle", { cx: "10", cy: "10", r: "6", fill: "currentColor" }) }));
}
function Stepper({ steps, currentIndex }) {
    return (_jsxs("div", { className: "pwa-stepper-container", children: [_jsx(Span, { variant: "label-small", bold: true, className: "pwa-stepper__current-step", children: steps[currentIndex] }), _jsx("ol", { className: "pwa-stepper", "aria-label": "Checkout progress", children: steps.map((label, index) => {
                    const state = stateFor(index, currentIndex);
                    return (_jsxs(Li, { variant: "label-small", listStyle: "disc", className: classNames('pwa-stepper__step', `pwa-stepper__step--${state}`), "aria-current": state === 'current' ? 'step' : undefined, children: [_jsxs(Span, { className: "pwa-stepper__indicator", "aria-hidden": "true", children: [state === 'completed' && _jsx(CompletedIcon, {}), state === 'current' && _jsx(CurrentIcon, {})] }), _jsx(Span, { variant: "label-small", bold: true, className: "pwa-stepper__label", children: label })] }, label));
                }) })] }));
}
export default Stepper;
